import { ArrowUpRight, Clock } from "lucide-react";
import { FadeUp } from "@/components/Reveal";
import { BLOG_POSTS } from "@/data/site";

export default function Blog() {
  return (
    <main className="pt-[72px]" data-testid="blog-page">
      <section className="grid-lines relative overflow-hidden border-b border-white/10">
        <div className="pointer-events-none absolute -top-32 right-1/4 h-[400px] w-[600px] rounded-full bg-[#D9A92E]/10 blur-[130px]" />
        <div className="relative mx-auto max-w-7xl px-4 py-20 sm:px-8 lg:px-12 lg:py-28">
          <FadeUp>
            <p className="mono text-xs uppercase tracking-[0.2em] text-[#E9C766] sm:text-sm">
              Insights & tech journal
            </p>
            <h1 className="font-display mt-4 max-w-3xl text-4xl font-extrabold leading-[1.08] tracking-tight text-white sm:text-5xl lg:text-6xl">
              Ideas that <span className="text-[#D9A92E]">spark results.</span>
            </h1>
            <p className="mt-6 max-w-xl text-lg leading-relaxed text-[#A1A1AA]">
              Field notes on SEO strategy, web performance, app scaling, domain strategy and
              conversion optimization — from the team that ships it.
            </p>
          </FadeUp>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 py-16 sm:px-8 lg:px-12 lg:py-24">
        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {BLOG_POSTS.map((post, i) => (
            <FadeUp key={post.slug} delay={i * 0.06}>
              <article
                className="group flex h-full flex-col rounded-2xl border border-white/10 bg-[#131316] p-7 transition-colors duration-300 hover:border-[#D9A92E]/50"
                data-testid={`blog-card-${post.slug}`}
              >
                <div className="flex items-center justify-between">
                  <span className="mono rounded-full bg-[#D9A92E]/12 px-3 py-1 text-[10px] uppercase tracking-[0.2em] text-[#E9C766]">
                    {post.category}
                  </span>
                  <span className="flex items-center gap-1.5 text-xs text-[#6B7280]">
                    <Clock className="h-3 w-3" />
                    {post.readTime}
                  </span>
                </div>
                <h2 className="mt-5 text-lg font-semibold leading-snug text-white transition-colors duration-300 group-hover:text-[#E9C766]">
                  {post.title}
                </h2>
                <p className="mt-3 text-sm leading-relaxed text-[#A1A1AA]">{post.excerpt}</p>
                <div className="mt-auto flex items-center justify-between pt-6">
                  <span className="text-xs text-[#6B7280]">{post.date}</span>
                  <span className="inline-flex items-center gap-1 text-sm font-semibold text-[#E9C766]">
                    Read
                    <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                  </span>
                </div>
              </article>
            </FadeUp>
          ))}
        </div>
      </section>
    </main>
  );
}
